/* istanbul ignore file */
export const shape = {
    borderRadius: 4,
};
